import { useTranslation } from 'react-i18next'
import { useRef, useState } from 'react'

import leftArrowSvg from '../../../../../../components/assets/arrow-left.svg'
import Calendar from '../../../../../../components/calendar/calendar'
import { useOutsideClickHandler } from '../../../../../../utils/use-outside-click-handler'
import { TrackedEvent, trackingService } from '../../../../../../services/tracking-service'

type InputProps = {
  onPreviousWeekPress: () => void
  onNextWeekPress: () => void
  additionalContainerClassName?: string
  selectedDate: Date
  setSelectedDate: (value: Date) => void
  setCurrentWeek: () => void
}
export const WeekToggle = ({
  onPreviousWeekPress,
  onNextWeekPress,
  additionalContainerClassName,
  selectedDate,
  setSelectedDate,
  setCurrentWeek,
}: InputProps) => {
  const { t } = useTranslation()
  const [showCalendar, setShowCalendar] = useState(false)
  const [hoveredDate, setHoveredDate] = useState<Date | null>(null)

  const calendarRef = useRef(null)

  useOutsideClickHandler(calendarRef, () => setShowCalendar(false))

  return (
    <div className={`CalendarHeader__weekToggle ${additionalContainerClassName}`}>
      {showCalendar && (
        <Calendar
          value={selectedDate}
          setValue={(value: Date | null) => {
            if (value) {
              const res = new Date(value)
              res.setHours(selectedDate.getHours(), selectedDate.getMinutes(), selectedDate.getSeconds())
              setSelectedDate(res)
            }
            setShowCalendar(false)

            trackingService.track(TrackedEvent.TimesheetWeekSwitchedViaCalendar)
          }}
          containerClassName="DateInput__Calendar CalendarHeader__weekToggle__calendar"
          hoveredDate={hoveredDate}
          setHoveredDate={setHoveredDate}
          ref={calendarRef}
          bottomActionTitle={t('all_jobs.current_week')}
          bottomActionCallback={() => {
            setCurrentWeek()
            setShowCalendar(false)
            trackingService.track(TrackedEvent.TimesheetCurrentWeekClicked)
          }}
          highlightWeek
        />
      )}
      <div className="CalendarHeader__right__toggle">
        <div
          onClick={() => {
            trackingService.track(TrackedEvent.TimesheetWeekBackClicked)
            onPreviousWeekPress()
          }}
          className="CalendarHeader__right__toggle__arrowContainer CalendarHeader__right__toggle__arrowContainer--left"
        >
          <img src={leftArrowSvg} className="CalendarHeader__right__toggle__arrowContainer__arrow" />
        </div>
        <button
          className="CalendarHeader__right__currentWeekButton"
          onClick={() => {
            setShowCalendar(true)
            trackingService.track(TrackedEvent.TimesheetCalendarSwitcherOpened)
          }}
        >
          🗓️ {t('all_jobs.week')}
        </button>
        <div
          onClick={() => {
            trackingService.track(TrackedEvent.TimesheetWeekForwardClicked)
            onNextWeekPress()
          }}
          className="CalendarHeader__right__toggle__arrowContainer CalendarHeader__right__toggle__arrowContainer--right"
        >
          <img src={leftArrowSvg} className="CalendarHeader__right__toggle__arrowContainer__arrow flipped" />
        </div>
      </div>
    </div>
  )
}
